import { Monitor, Refresh, SignalCellularAlt1Bar, SignalCellularAlt2Bar, SignalCellularAltOutlined } from '@mui/icons-material';
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Tooltip as MatToolTip, Tab, Tabs, Typography } from "@mui/material";
import BuildReportsPage from 'components/BuildReports/BuildReportsPage';
import MemoryPage from 'components/Common/Memory/MemoryPage';
import FunctionsPage from 'components/Functions/FunctionsPage';
import PublicPage from 'components/PublicPage/PublicPage';
import TestScenarioDetail from 'components/TestScenarios/TestScenarioDetail';
import TransactionHistory from 'components/TransactionHistory/TransactionHistory';
import VariableSet from 'components/VariableSet/VariableSet';
import { LOCAL_STORAGE_KEY_FOR_ENVIRONMENT } from 'config/constants';
import { MixpanelService } from 'utils/mixpanelService';
import {
    ArrowDownIcon,
    ChevronDown,
    ChevronDownIcon,
    ChevronRightIcon,
    CircleFadingArrowUp,
    GalleryVerticalEnd,
    Import,
    LoaderCircle,
    MenuIcon,
    Play,
    Plus,
    SendHorizonal,
    Settings
} from 'lucide-react';
import { motion } from "motion/react";
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { Tooltip } from 'primereact/tooltip';
import { useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import { setSelectedProject as setSelectedProjectInState } from 'reducers/commonSlice.js';
import {
    addCollection,
    addEntitiesToChat,
    addEnvironment,
    addTestScenarioRequest,
    getChat,
    getMsg,
    getOlderMsg,
    postMsg,
    startChat,
    switchAIModel
} from 'redux-store/aiChatsReducers/aiChatsActions';
import {
    fetchCollectionsList,
    importCollection,
    updateCollectionImport
} from 'redux-store/collectionActions';
import { getProject } from 'redux-store/currentUserActions';
import { fetchOrganisations as fetchGlobalOrganisations } from 'redux-store/dashboardActions';
import { getAllVariableSets as fetchEnvironments } from 'redux-store/variableSetReducers/variableSetActions';
import { useSnackbar } from "../../contexts/CustomSnackbarContext";
import { useSidebar } from '../../contexts/SidebarContext';
import { useS3Upload } from '../../utils/useS3Upload';
import AiAgentSidebar from './AiAgentSidebar';
import BlankScreen from './BlankScreen';
import CenteredChatLayout from './CenteredChatLayout';
import DefaultTab from './DefaultTab';
import GeneratedTestScenariosTab from './GeneratedTestScenariosTab';
import "./index.css";
import MessageResponse from './MessageResponse';
import ProgressTab from './ProgressTab';
import ShowLongMessage from './ShowLongMessage';
import SwaggerScreen from './SwaggerScreen';
import ThinkingIndicator from './ThinkingIndicator';

const TestCaseGeneratorBot = ({ currentUser, project }) => {
    const history = useHistory();
    const { toggleSidebar, isSidebarCollapsed } = useSidebar();
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const chatIdFromQuery = query.get("chatId");
    const newChatParam = query.get("newChat");
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingOlder, setIsLoadingOlder] = useState(false);
    const [messages, setMessages] = useState([]);
    const [oldestMessageId, setOldestMessageId] = useState(null);
    const [hasMoreMessages, setHasMoreMessages] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);
    const [collections, setCollections] = useState([]);
    const [selectedCollection, setSelectedCollection] = useState([]);
    const [selectedChatEntityIds, setSelectedChatEntityIds] = useState(null);
    const [user, setUser] = useState(currentUser);
    const [tabs, setTabs] = useState([{
        id: "default",
        type: "new",
        title: "Welcome",
        subtitle: "Welcome"
    }]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [submenuOpen, setSubmenuOpen] = useState(null);
    const [environment, setEnvironment] = useState([]);
    const [selectedEnvironmentId, setSelectedEnvironmentId] = useState(null);
    const messagesContainerRef = useRef(null);
    const collectionsDialogRef = useRef(null);
    const modelsDialogRef = useRef(null);
    const chatDropDownOptionsRef = useRef(null);
    const collectionsButtonRef = useRef(null);
    const fileInputRef = useRef(null);
    const fileInputRefImport = useRef(null);
    const [fileAccept, setFileAccept] = useState(".json");
    const [selectedImportType, setSelectedImportType] = useState("postman")
    const [input, setInput] = useState('');
    const messagesEndRef = useRef(null);
    const { openSnackbar } = useSnackbar();
    const [selectedProject, setSelectedProject] = useState(null);
    const [chatId, setChatId] = useState(null);
    const pollingIntervalRef = useRef(null);
    const isMounted = useRef(true);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [showEnvMemoryInput, setShowEnvMemoryInput] = useState(false);
    const [saveInEnvironment, setSaveInEnvironment] = useState(false);
    const [saveInMemory, setSaveInMemory] = useState(false);
    const [showSplitter, setShowSplitter] = useState(false);

    const aiModels = useMemo(() => [
        {
            id: "gpt-4.1",
            name: "GPT 4.1",
            value: "gpt-4.1-2025-04-14",
            displayName: "gpt-4.1",
            icon: <SignalCellularAlt1Bar sx={{ color: '#00897B', fontSize: "13px" }} />,
            content: "Uses regular token consumption.",
            inputToken: "",
            outputToken: "",
            isEnabled: true
        },
        {
            id: "o3",
            name: "o3",
            value: "o3-2025-04-16",
            displayName: "o3",
            icon: <SignalCellularAlt2Bar sx={{ color: '#00897B', fontSize: "13px" }} />,
            content: "Consumes 4x the tokens of GPT 4.1.",
            inputToken: "",
            outputToken: "",
            isEnabled: true
        },
        {
            id: "gpt-5.2",
            name: "GPT 5.2",
            value: "gpt-5.2-2025-12-11",
            displayName: "gpt-5.2",
            icon: <SignalCellularAltOutlined sx={{ color: '#00897B', fontSize: "13px" }} />,
            content: "Uses higher token than the o3.",
            inputToken: "",
            outputToken: "",
            isEnabled: true
        }
    ], [project])

    const tabComponents = {
        "test-scenario": (tab) => {
            return (
                <TestScenarioDetail
                    project={selectedProject}
                    testScenarioId={tab.id}
                    isAiAgent={true}
                    createTestScenarioRequestAIAgent={handleTestScenarioCreateRequest}
                    expandTestCaseIdOnLoad={tab.testCaseSetId || null}
                />
            );
        },
        "environment": (tab) => <VariableSet project={selectedProject} variableSetId={tab.id} />,
        "memory": (tab) => <MemoryPage projectId={selectedProject?.id} />,
        "new": (tab) => <DefaultTab
            user={user}
            onPromptClick={handlePromptClick}
            chatId={chatId}
            selectedCollection={selectedCollection}
            selectedEnvironment={selectedEnvironmentId}
            collections={collections}
            environments={environment}
            project={selectedProject}
            showPrompts={true}
            handleImport={handleFileImport}
            handleOpenTab={handleOpenTab}
        />,
        "function": (tab) => <FunctionsPage projectId={selectedProject?.id} />,
        "public-page": (tab) => <PublicPage project={selectedProject} />,
        "build-reports": (tab) => <BuildReportsPage projectId={selectedProject?.id} />,
        "transactions": (tab) => <TransactionHistory projectId={selectedProject?.id} />,
        "progress": (tab) => <ProgressTab
            chatId={chatId}
            selectedCollection={selectedCollection}
            selectedEnvironment={selectedEnvironmentId}
            collections={collections}
            environments={environment}
            handleOpenTab={handleOpenTab}
            generatedTestScenarios={generatedTestScenarios}
        />,
        "collection-swagger": (tab) => <SwaggerScreen
            collection={tab}
            addEntityToChatContext={handleAddEntityToChatContext}
            isAiAgent={true}
            selectedChatEntityIds={selectedChatEntityIds}
            isProcessing={isProcessing}
        />,
        "long-message": (tab) => <ShowLongMessage message={tab.message} />,
        "generated-test-scenarios": (tab) => <GeneratedTestScenariosTab
            chatId={chatId}
            handleOpenTab={handleOpenTab}
            generatedTestScenarios={generatedTestScenarios}
            getChatDetails={getChatDetails}
        />
    };
    const [refreshKeys, setRefreshKeys] = useState({});
    const [loadingTabs, setLoadingTabs] = useState({});
    const { uploadFile } = useS3Upload();
    const [userHasScrolled, setUserHasScrolled] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const userHasScrolledRef = useRef(false);
    const [latestMessageId, setLatestMessageId] = useState(null);
    const tabTypeForCustomBg = ['new', 'progress', "long-message"];
    const tabTypesForConditionalRender = ["test-scenario"];
    const [isNewTabOpened, setIsNewTabOpened] = useState(false);
    const [generatedTestScenarios, setGeneratedTestScenarios] = useState([]);
    const [selectedAIModel, setSelectedAIModel] = useState("gpt-5.2-2025-12-11");

    useEffect(() => {
        userHasScrolledRef.current = userHasScrolled;
    }, [userHasScrolled]);

    useEffect(() => {
        const checkMessageForChat = async () => {
            if (messages.length > 0) {
                const latestMessage = messages[messages.length - 1];
                const chatIdForFetch = chatId ?? chatIdFromQuery;
                setLatestMessageId(latestMessage.id);

                // Handle skip step check
                const hasSkipStep = latestMessage.suggestions?.some(suggestion => {
                    const text = typeof suggestion === 'object'
                        ? (suggestion.description || suggestion.title || '')
                        : suggestion;
                    return text.toLowerCase().includes('skip this step') ||
                        text.toLowerCase().includes('skip this scenario');
                }) ?? false;

                setShowEnvMemoryInput(hasSkipStep);

                let shouldRefetchChatDetails = false;

                // Handle collection fetch
                if (latestMessage.selected_collection !== undefined && selectedProject?.id && chatIdForFetch) {
                    await fetchCollectionsData(selectedProject.id);
                    shouldRefetchChatDetails = true;
                }

                // Handle scenario-based fetch
                const prevMessage = messages[messages.length - 2];
                if (prevMessage?.generated_test_scenarios?.length > 0 && selectedProject?.id && chatIdForFetch) {
                    shouldRefetchChatDetails = true;
                }

                if (shouldRefetchChatDetails) {
                    await getChatDetails(chatIdForFetch);
                }
            }
        };

        checkMessageForChat();
    }, [messages, chatId, chatIdFromQuery]);

    // Handle newChat parameter
    useEffect(() => {
        if (newChatParam === "true") {
            resetChatState();
            // Remove newChat parameter from URL
            const newUrl = new URL(window.location);
            newUrl.searchParams.delete("newChat");
            history.replace(newUrl.pathname + newUrl.search);
        }
    }, [newChatParam]);

    const refreshTab = (tabId) => {
        setLoadingTabs((prev) => ({ ...prev, [tabId]: true }));
        setTimeout(() => {
            setRefreshKeys((prev) => ({
                ...prev,
                [tabId]: (prev[tabId] || 0) + 1,
            }));
            setLoadingTabs((prev) => ({ ...prev, [tabId]: false }));
        }, 1000);
    };

    const handleFileImport = (type) => {
        if (isProcessing) {
            openSnackbar({
                message: "Please wait for the current operation to complete.",
                severity: 'info'
            });
            return;
        }
        const newFileAccept = type === "postman" ? ".json" : ".json, .yml, .yaml";
        setFileAccept(newFileAccept);
        setSelectedImportType(type);

        if (!fileInputRefImport || !fileInputRefImport.current) {
            console.error("File input ref not initialized");
            return;
        }

        fileInputRefImport.current.accept = newFileAccept;
        fileInputRefImport.current.click();
    };

    const handleImportCollections = async (event, importType) => {
        let aiChatRequired = !chatId ? true : false;
        const file = event.target.files[0];
        if (!file) {
            alert('No file selected!');
            return;
        }

        if (importType === 'postman' && !file.name.endsWith('.json')) {
            alert('Please select a JSON file.');
            return;
        }

        if (importType === 'swagger' && !file.name.endsWith('.json') && !file.name.endsWith('.yml') && !file.name.endsWith('.yaml')) {
            alert('Please select a JSON file or a YAML file.');
            return;
        }

        uploadFile(file)
            .then(({ data, url }) => {
                dispatch(
                    importCollection({ s3Url: url, projectId: selectedProject?.id, importType: importType, aiChatId: chatId, aiChatRequired: aiChatRequired })
                ).then((res) => {
                    if (res.payload?.error) {
                        openSnackbar({ message: res.payload.error, severity: 'error' });
                        return;
                    }
                    if (collectionsDialogRef.current) {
                        collectionsDialogRef.current.hide();
                    }
                    if (res.payload?.conflicting_collection_found) {
                        confirmDialog({
                            message: `A collection named "${res.payload.collection_name}" already exists. Would you like to override the existing collection or create a new one?`,
                            header: 'Already Exists',
                            defaultFocus: 'accept',
                            acceptLabel: "Create New",
                            rejectLabel: "Override Existing",
                            closable: false,
                            accept: () => handleConflictingImport(res.payload.id, true),
                            reject: () => handleConflictingImport(res.payload.id, false),
                        });
                    } else {
                        setTimeout(async () => {
                            await fetchCollectionsData(selectedProject?.id);
                            if (chatId) {
                                await startPolling(chatId);
                            } else {
                                const newChatId = res.payload?.ai_chat_id;
                                history.replace(`/ai-agent?chatId=${newChatId}`, {
                                    replace: true
                                });
                            }
                            openSnackbar({
                                message: "Collection imported successfully!",
                                severity: 'success'
                            });
                        }, 1000);
                    }
                });
            })
            .catch((error) => {
                console.error('Upload failed:', error);
            })
            .finally(() => {
                if (fileInputRefImport.current) {
                    fileInputRefImport.current.value = '';
                }
            });
    };

    const handleConflictingImport = async (collectionId, isCreateNew) => {
        try {
            const response = await dispatch(
                updateCollectionImport({
                    importId: collectionId,
                    createAsNew: isCreateNew,
                    projectId: selectedProject?.id,
                    aiChatRequired: !chatId ? true : false
                })
            );
            if (response.payload) {
                setTimeout(async () => {
                    await fetchCollectionsData(selectedProject?.id);
                    if (chatId) {
                        await startPolling(chatId);
                    } else {
                        const newChatId = response.payload?.ai_chat_id;
                        history.replace(`/ai-agent?chatId=${newChatId}`, {
                            replace: true
                        });
                    }
                    openSnackbar({
                        message: "Collection imported successfully!",
                        severity: 'success'
                    });
                }, 1000);
            }
        } catch (error) {
            console.error("Error handling conflicting import:", error);
            openSnackbar({
                message: "Error updating collection",
                severity: 'error'
            });
        }
    };

    const scrollToBottom = () => {
        if (messagesEndRef.current) {
            setTimeout(() => {
                messagesEndRef.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "end"
                });
            }, 200);
        }
    };

    const openPreview = (messages) => {
        const firstMessage = messages[0];
        if (firstMessage.current_test_scenario) {
            handleOpenTab({
                title: firstMessage.current_test_scenario.title,
                type: "test-scenario",
                id: firstMessage.current_test_scenario.test_scenario_id,
            }, "test-scenario")
        }
    }

    const fetchCollectionsData = async (projectId) => {
        if (!projectId) return;
        try {
            const response = await dispatch(fetchCollectionsList({ projectId: projectId })).unwrap();
            setCollections(response);
        } catch (error) {
            console.error("Error fetching collections:", error);
            openSnackbar({
                message: "Error fetching collections.",
                severity: 'error'
            });
        }
    };

    useEffect(() => {
        if (selectedProject && chatIdFromQuery) {
            getChatDetails(chatIdFromQuery);
            handleOpenTab({
                id: "progress",
                type: "progress",
                title: "Progress",
                subtitle: "Progress",
                icon: <Play className='text-blue-600' size={16} />
            }, "progress", true);
        }
    }, [selectedProject, chatIdFromQuery]);

    const getChatDetails = async (chatDetailsId) => {
        try {
            const response = await dispatch(getChat({ aiChatId: chatDetailsId })).unwrap();
            if (response.status === 200) {
                const context = response.data?.context || {};
                if (context?.collection_ids) {
                    setSelectedCollection(context.collection_ids);
                }
                if (context?.environment_set_id) {
                    setSelectedEnvironmentId(context.environment_set_id);
                }
                if (context?.entity_ids) {
                    setSelectedChatEntityIds(context.entity_ids)
                }
                if (context?.generated_test_scenarios && context?.generated_test_scenarios.length > 0) {
                    setGeneratedTestScenarios(context.generated_test_scenarios);
                }
                if (context?.ai_model) {
                    setSelectedAIModel(context.ai_model)
                }
                // await refreshSelectedProject(response.data.project_id);
                if (!chatId) {
                    setChatId(chatDetailsId);
                }
            }
        } catch (error) {
            openSnackbar({
                message: "Starting New Chat. Error fetching Chat Details.",
                severity: 'error'
            });
            await resetChatState();
            history.push('/ai-agent?newChat=true');
        }
    }

    const refreshSelectedProject = async (projectId) => {
        if (!projectId) return;
        const response = await dispatch(getProject({ projectId: projectId })).unwrap();
        localStorage.setItem('lastSelectedProject', JSON.stringify(response));
    }

    const getTabBgClass = (tabType) => {
        return !tabTypeForCustomBg.includes(tabType) ? 'bgPrimary bg-opacity-95' : '';
    };

    const fetchOrganisations = async () => {
        const fetchedOrganisation = await dispatch(fetchGlobalOrganisations({}));
        const organisationsData = fetchedOrganisation.payload;

        if (organisationsData.length > 0 && organisationsData[0].projects.length > 0) {
            const firstProject = fetchedOrganisation.payload[0].projects[0];
            const response = await dispatch(getProject({ projectId: firstProject?.id }));
            await dispatch(setSelectedProjectInState(response.payload));
            localStorage.setItem('lastSelectedProject', JSON.stringify(firstProject));
            localStorage.removeItem(LOCAL_STORAGE_KEY_FOR_ENVIRONMENT);
        }
    };

    useEffect(() => {
        const loadInitialData = async () => {
            let storedProject = JSON.parse(localStorage.getItem("lastSelectedProject"));
            if (!storedProject) {
                await fetchOrganisations();
                storedProject = JSON.parse(localStorage.getItem("lastSelectedProject"));
            }
            setSelectedProject(storedProject);
            refreshSelectedProject(storedProject?.id);
            // const userDetails = JSON.parse(localStorage.getItem("user"));
            // setUser(userDetails);
            const fetchProjectEnvironment = async () => {
                try {
                    const response = await dispatch(fetchEnvironments({ projectId: storedProject?.id })).unwrap();
                    setEnvironment(response?.variable_sets);
                } catch (error) {
                    console.error("Error fetching environments:", error);
                    openSnackbar({
                        message: "Error fetching environments.",
                        severity: 'error'
                    });
                }
            }
            fetchCollectionsData(storedProject?.id);
            fetchProjectEnvironment();

            // Check for startAIQuery in localStorage and set it in input
            const savedQuery = localStorage.getItem("startAIQuery");
            if (savedQuery) {
                localStorage.removeItem("startAIQuery"); // Remove it after setting
                startChartFromSelectedQuery(storedProject?.id, savedQuery);
            }
        }

        loadInitialData();
    }, []);

    const handlePromptClick = (prompt) => {
        setInput(prompt);
    };

    const mergeMessages = (existingMessages, newMessages) => {
        const currentOldestId = existingMessages.length > 0 ? Math.min(...existingMessages.map(msg => msg.id)) : Infinity;
        const currentNewestId = existingMessages.length > 0 ? Math.max(...existingMessages.map(msg => msg.id)) : -Infinity;

        const messageMap = new Map();
        existingMessages.forEach(msg => messageMap.set(msg.id, msg));
        newMessages.forEach(newMsg => messageMap.set(newMsg.id, newMsg));
        const mergedMessages = [...messageMap.values()].sort((a, b) => a.id - b.id);

        const hasOlderMessages = newMessages.some(msg => msg.id < currentOldestId);
        const hasNewerMessages = newMessages.some(msg => msg.id > currentNewestId);

        if (hasNewerMessages && !userHasScrolledRef.current && !hasOlderMessages) {
            setTimeout(() => {
                scrollToBottom();
            }, 150);
        }
        return mergedMessages;
    };

    const startPolling = (currentChatId) => {
        return new Promise((resolve) => {
            if (pollingIntervalRef.current) {
                return resolve();
            }

            pollingIntervalRef.current = setInterval(async () => {
                try {
                    const response = await dispatch(getMsg({ aiChatId: currentChatId }));
                    if (response.payload?.data?.ai_chat_messages) {
                        const rawMessages = response.payload.data.ai_chat_messages;
                        const hasLoadingMessage = rawMessages.some(msg => msg.loading === true);
                        setMessages(prevMessages => {
                            const mergedMessages = mergeMessages(prevMessages, rawMessages);
                            return mergedMessages;
                        });

                        if (!hasLoadingMessage) {
                            refreshSelectedProject(selectedProject?.id);
                            stopPolling();
                            setIsProcessing(false);
                            resolve();
                        } else {
                            setIsProcessing(true);
                        }
                    }
                } catch (error) {
                    console.error('Polling error:', error);
                    stopPolling();
                    resolve();
                }
            }, 3000);
        });
    };

    const stopPolling = () => {
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
        }
    };

    let loadOlderMessagesTimeout;

    const handleScroll = async (e) => {
        const element = e.target;
        const isNearTop = element.scrollTop < 50;
        const distanceFromBottom = element.scrollHeight - element.scrollTop - element.clientHeight;

        const isScrolledUpFromBottom = distanceFromBottom > 350;
        setUserHasScrolled(isScrolledUpFromBottom);

        if (isNearTop && !isLoadingOlder && hasMoreMessages && oldestMessageId && chatId) {
            if (!loadOlderMessagesTimeout) {
                loadOlderMessagesTimeout = setTimeout(async () => {
                    await loadOlderMessages();
                    loadOlderMessagesTimeout = null;
                }, 100);
            }
        }
    };

    const loadOlderMessages = async () => {
        if (!hasMoreMessages || isLoadingOlder) return;
        try {
            setIsLoadingOlder(true);
            const response = await dispatch(getOlderMsg({
                aiChatId: chatId,
                oldMsgId: oldestMessageId
            }));

            if (response.payload?.data?.ai_chat_messages?.length > 0) {
                const olderMessages = response.payload.data.ai_chat_messages;
                setOldestMessageId(Math.min(...olderMessages.map(msg => msg.id)));

                setMessages(prevMessages => mergeMessages(prevMessages, olderMessages));
            } else {
                setHasMoreMessages(false);
            }
        } catch (error) {
            console.error('Error loading older messages:', error);
        } finally {
            setIsLoadingOlder(false);
        }
    };

    useEffect(() => {
        let mounted = true;
        const initializeChat = async () => {
            try {
                setIsLoading(true);
                if (chatId) {
                    const response = await dispatch(getMsg({ aiChatId: chatId }));
                    if (!mounted) return;
                    if (response.payload?.data?.ai_chat_messages) {
                        const newMessages = response.payload.data.ai_chat_messages;

                        setMessages(prevMessages => {
                            const mergedMessages = mergeMessages(prevMessages, newMessages);
                            return mergedMessages;
                        });
                        openPreview(newMessages.reverse());
                        if (newMessages.length > 0) {
                            setOldestMessageId(newMessages[newMessages.length - 1].id);
                            if (isFirstLoad) {
                                setTimeout(() => {
                                    scrollToBottom();
                                    setIsFirstLoad(false);
                                }, 200);
                            }
                        }

                        if (newMessages.some(msg => msg.loading === true)) {
                            startPolling(chatId);
                        }
                    }
                }
            } catch (error) {
                console.error('Error initializing chat:', error);
            } finally {
                if (mounted) {
                    setIsLoading(false);
                    setTimeout(() => {
                        scrollToBottom();
                    }, 600);
                }
            }
        };

        initializeChat();
        return () => {
            mounted = false;
            stopPolling();
        };
    }, [chatId]);

    const startChartFromSelectedQuery = async (projectId, query) => {
        let currentChatId = chatId;
        if (!chatId && projectId) {
            const startChatResponse = await dispatch(startChat({
                projectId: projectId,
                userMsg: query
            }));

            if (startChatResponse.payload?.id) {
                currentChatId = startChatResponse.payload.id;
                setChatId(currentChatId);
                MixpanelService.track("ai_agent_chat_started", { chat_id: currentChatId });
                history.replace(`/ai-agent?chatId=${currentChatId}`, {
                    replace: true
                });
                stopPolling();
                startPolling(currentChatId);
                handleOpenTab({
                    id: "progress",
                    type: "progress",
                    title: "Progress",
                    subtitle: "Progress",
                    icon: <Play className='text-blue-600' size={16} />
                }, "progress", true);
            }
        }
    }

    const handleSubmit = async (e) => {
        const messageText = input.trim();
        if (messageText === "") return false;
        setInput('');
        setIsProcessing(true);
        setUserHasScrolled(false);

        try {
            let currentChatId = chatId;

            if (!chatId) {
                const startChatResponse = await dispatch(startChat({
                    projectId: selectedProject?.id,
                    userMsg: messageText,
                    aiModel: selectedAIModel
                }));

                if (startChatResponse.payload?.id) {
                    currentChatId = startChatResponse.payload.id;
                    setChatId(currentChatId);
                    MixpanelService.track("ai_agent_chat_started", { chat_id: currentChatId });
                    history.replace(`/ai-agent?chatId=${currentChatId}`, {
                        replace: true
                    });
                    stopPolling();
                    startPolling(currentChatId);
                    handleOpenTab({
                        id: "progress",
                        type: "progress",
                        title: "Progress",
                        subtitle: "Progress",
                        icon: <Play className='text-blue-600' size={16} />
                    }, "progress", true);
                } else {
                    throw new Error('Failed to initialize chat');
                }
            } else {
                const response = await dispatch(postMsg({
                    aiChatId: currentChatId,
                    userMsg: messageText,
                    saveInEnv: saveInEnvironment,
                    saveInMemory: saveInMemory,
                }));

                if (response.payload?.data?.ai_chat_messages) {
                    const newMessages = response.payload.data.ai_chat_messages;
                    setSaveInEnvironment(false);
                    setSaveInMemory(false);
                    setMessages(prevMessages => {
                        const mergedMessages = mergeMessages(prevMessages, newMessages);
                        return mergedMessages;
                    });

                    setTimeout(scrollToBottom, 100);

                    if (newMessages.some(msg => msg.loading === true)) {
                        stopPolling();
                        startPolling(currentChatId);
                    } else {
                        setIsProcessing(false);
                    }
                }
            }
        } catch (error) {
            setIsProcessing(false);
            openSnackbar({
                message: "Failed to send message. Please try again.",
                severity: 'error'
            });
        }
    };


    const handleTryAgain = async () => {
        if (isProcessing || !chatId) {
            openSnackbar({
                message: "AI Agent is processing. Please wait.",
                severity: 'info'
            });
            return;
        };
        setIsProcessing(true);
        setUserHasScrolled(false);
        let currentChatId = chatId;
        const response = await dispatch(postMsg({
            aiChatId: currentChatId,
            userMsg: "Try Again",
            saveInEnv: saveInEnvironment,
            saveInMemory: saveInMemory,
        }));

        if (response.payload?.data?.ai_chat_messages) {
            const newMessages = response.payload.data.ai_chat_messages;
            setSaveInEnvironment(false);
            setSaveInMemory(false);
            setMessages(prevMessages => {
                const mergedMessages = mergeMessages(prevMessages, newMessages);
                return mergedMessages;
            });

            setTimeout(scrollToBottom, 100);

            if (newMessages.some(msg => msg.loading === true)) {
                stopPolling();
                startPolling(currentChatId);
            } else {
                setIsProcessing(false);
            }
        }
    }

    const handleFileUpload = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        openSnackbar({ message: "Copied Successfully!", severity: 'info' });
    };

    const handleSelectCollectionSelection = async (selectedCollection) => {
        try {
            const response = await dispatch(
                addCollection({ aiChatId: chatId, collectionIds: selectedCollection })
            )
            if (response.payload.status === 200) {
                if (!chatId) {
                    let chatIdFromCollectionSelect = response.payload?.data?.id;
                    history.replace(`/ai-agent?chatId=${chatIdFromCollectionSelect}`, {
                        replace: true
                    });
                } else {
                    setIsProcessing(true);
                    stopPolling();
                    startPolling(chatId);
                }
            }
        } catch (error) {
            console.error("Error adding collections:", error);
            openSnackbar({ message: "Error adding collections", severity: 'error' });
        }
    };

    const addSelectedEnvironment = async (selectedEnvironmentId, chatIdFromQuery) => {
        if (!selectedEnvironmentId) return;
        try {
            await dispatch(addEnvironment({ aiChatId: chatIdFromQuery, environmentId: selectedEnvironmentId }));
            openSnackbar({ message: "Environment updated successfully!", severity: 'success' });
        } catch (error) {
            console.error("Error Updating Environment:", error);
            openSnackbar({ message: "Error Updating Environment", severity: 'error' });
        }
    };

    const handleKeyDown = (e) => {
        if (!isProcessing) {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                if (input.trim()) {
                    handleSubmit();
                }
            }
        }
    };

    useEffect(() => {
        return () => {
            stopPolling();
        };
    }, []);

    useEffect(() => {
        return () => {
            isMounted.current = false;
            stopPolling();
        };
    }, []);

    const handleCollectionSelect = (collection) => {
        if (isProcessing) {
            openSnackbar({
                message: "Please wait until the processing is completed.",
                severity: 'info',
                horizontalPos: 'left'
            });
            return;
        }

        if (selectedCollection.length > 0) {
            openSnackbar({
                message: "A collection is already selected. Start a new chat to select a different collection.",
                severity: 'info',
                horizontalPos: 'left'
            });
            return;
        }

        setSelectedCollection([collection.id]);
        if (collectionsDialogRef.current) {
            collectionsDialogRef.current.hide();
        }
        handleSelectCollectionSelection([collection.id]);
    };

    const handleEnvironmentSelect = (env) => {
        setSelectedEnvironmentId(env.id);
        addSelectedEnvironment(env.id, chatId);
        setSubmenuOpen(null);
        if (collectionsDialogRef.current) {
            collectionsDialogRef.current.hide();
        }
    };

    const handleOpenTab = (tab, type, notOpen = false) => {
        setTabs((prevTabs) => {
            const existingTabIndex = prevTabs.findIndex((t) => t.id === tab.id && t.type === type);
            if (existingTabIndex !== -1) {
                const updatedTabs = [...prevTabs];
                updatedTabs[existingTabIndex] = { ...tab, type };
                if (!notOpen) {
                    setActiveIndex(existingTabIndex);
                }
                refreshTab(tab.id);
                return updatedTabs;
            }

            const updatedTabs = [...prevTabs, { ...tab, type }];
            if (!notOpen) {
                setActiveIndex(updatedTabs.length - 1);
            }
            return updatedTabs;
        });
    };

    const handleCloseTab = (tabId) => {
        setTabs((prevTabs) => {
            const newTabs = prevTabs.filter((tab) => tab.id !== tabId);
            let newActiveIndex = activeIndex;

            if (newTabs.length === 0) {
                newActiveIndex = 0;
            } else if (activeIndex >= newTabs.length) {
                newActiveIndex = newTabs.length - 1;
            }

            setActiveIndex(newActiveIndex);
            return newTabs;
        });
    };

    const resetChatState = () => {
        return new Promise((resolve) => {
            stopPolling();
            fetchCollectionsData(selectedProject?.id);
            setChatId(null);
            setMessages([]);
            setOldestMessageId(null);
            setHasMoreMessages(true);
            setIsProcessing(false);
            setIsLoading(false);
            setIsLoadingOlder(false);
            setSelectedCollection([]);
            setSelectedChatEntityIds(null);
            setTabs([{
                id: "default",
                type: "new",
                title: "Welcome",
                subtitle: "Welcome"
            }]);
            setActiveIndex(0);
            setSubmenuOpen(null);
            setSelectedEnvironmentId(null);
            setInput('');
            setRefreshKeys({});
            setLoadingTabs({});
            setLatestMessageId(null);
            setUserHasScrolled(false);
            messagesContainerRef.current = null;
            collectionsDialogRef.current = null;
            modelsDialogRef.current = null;
            chatDropDownOptionsRef.current = null;
            fileInputRef.current = null;
            messagesEndRef.current = null;
            pollingIntervalRef.current = null;
            userHasScrolledRef.current = false;
            setShowEnvMemoryInput(false);
            setSaveInEnvironment(false);
            setSaveInMemory(false);
            setIsNewTabOpened(false);
            setGeneratedTestScenarios([]);
            setShowSplitter(false);
            setTimeout(resolve, 0);
        });
    };

    const removeCollection = (id) => {
        setSelectedCollection((prev) => prev.filter((item) => item !== id));
    };

    const removeEnvironment = () => {
        setSelectedEnvironmentId(null);
    };

    const menuData = useMemo(() => {
        const importDisabled = selectedCollection.length > 0 || isProcessing;
        const importDisabledMsg = isProcessing ? "AI Agent is Processing, Please Wait." : "Cannot import while a collection is selected";

        const environmentItems = environment.map(env => ({
            label: env.title,
            command: () => handleEnvironmentSelect(env),
            id: env.id,
            isDisabled: isProcessing || !chatId,
            disabledMessage: isProcessing
                ? "Please wait till the processing is completed"
                : ""
        }));

        return [
            {
                label: "Import Collection",
                icon: <Import size={16} />,
                isDisabled: false,
                items: [
                    {
                        label: "Postman",
                        command: () => handleFileImport("postman"),
                        isDisabled: importDisabled,
                        disabledMessage: importDisabledMsg
                    },
                    {
                        label: "Swagger",
                        command: () => handleFileImport("swagger"),
                        isDisabled: importDisabled,
                        disabledMessage: importDisabledMsg
                    }
                ]
            },
            {
                label: "Environment",
                icon: <Settings size={16} />,
                isDisabled: false,
                items: environmentItems
            }
        ];
    }, [environment, selectedEnvironmentId, selectedCollection, isProcessing]);


    const handleAddEntityToChatContext = async (entityIds) => {
        if (isProcessing) {
            openSnackbar({
                message: "AI Agent is processing. Please wait.",
                severity: 'info'
            });
            return;
        }
        try {
            const response = await dispatch(
                addEntitiesToChat({ aiChatId: chatId, entityIds: entityIds })
            )
            if (response.payload.status === 200) {
                setIsProcessing(true);
                openSnackbar({ message: "Selected APIs added to AI Agent Chat Context.", severity: 'info' });
                stopPolling();
                await startPolling(chatId);
                await getChatDetails(chatId);
                // Find and refresh the collection-swagger tab
                const swaggerTab = tabs.find(tab => tab.type === 'collection-swagger');
                if (swaggerTab) {
                    refreshTab(swaggerTab.id);
                }
                setTimeout(() => {
                    scrollToBottom();
                }, 100)
            }
        } catch (error) {
            console.error("Some error occurred:", error);
            openSnackbar({ message: "Some error occurred. Please Try Again.", severity: 'error' });
        }
    };

    const handleTestScenarioCreateRequest = async (testScenarioId) => {
        if (isProcessing) {
            openSnackbar({
                message: "AI Agent is processing. Please wait.",
                severity: 'info'
            });
            return;
        }
        try {
            const response = await dispatch(
                addTestScenarioRequest({ aiChatId: chatId, testScenarioId: testScenarioId })
            )
            if (response.payload.status === 200) {
                openSnackbar({ message: "Request creation initiated for Test Scenario. Please check the AI Agent for updates.", severity: 'info' });
                setIsProcessing(true);
                stopPolling();
                startPolling(chatId);
                setTimeout(() => {
                    scrollToBottom();
                }, 100)
            }
        } catch (error) {
            console.error("Error Creating Test Scenario Request:", error);
            openSnackbar({ message: "Error Creating Test Scenario Request", severity: 'error' });
        }
    };

    const handleSelectChat = async (oldChatId) => {
        await resetChatState();
        history.replace(`/ai-agent?chatId=${oldChatId}`, {
            replace: true
        });
        setTimeout(() => {
            if (chatDropDownOptionsRef.current) {
                chatDropDownOptionsRef.current.hide();
            }
            setSidebarVisible(false);
        }, 500);
    }

    const handleModelSelect = async (selectedModel) => {
        modelsDialogRef.current.hide();
        if (chatId) {
            try {
                const response = await dispatch(
                    switchAIModel({ aiChatId: chatId, modelId: selectedModel })
                )
                if (response?.payload) {
                    setSelectedAIModel(selectedModel);
                }
            } catch (error) {
                console.error("Error Switching AI Model:", error);
            }
        } else {
            setSelectedAIModel(selectedModel);
        }
    }
    return (
        <div key={chatId} className="w-full h-[calc(100vh-45px)] flex flex-col bgPrimary custom_font">
            <ConfirmDialog />
            <OverlayPanel ref={modelsDialogRef} className="w-56 bg-[var(--overlay-bg)] border !border-[var(--borderColor)]">
                <ul className="w-full !pl-0 list-none mb-0 overflow-y-auto max-h-48 chatscreen-custom-scrollbar">
                    {aiModels.map((model) => (
                        <MatToolTip sx={{ border: "1px solid var(--borderColor)" }} title={
                            <div className='w-56 text-[var(--text-primary)]'>
                                <div className='my-1 fs13'>{model.name}</div>
                                <div className='fs12 mb-1'>{model.content}</div>
                                {/* <div className='text-[var(--text-secondary)] my-1 font-normal fs11'>{model.inputToken}<br />{model.outputToken}</div> */}
                                {!model.isEnabled && (
                                    <div className='text-red-500 my-1 font-normal fs11'>Note: This is not available to users who are on Free Plan.</div>
                                )}
                            </div>
                        } placement="right" arrow>
                            <li
                                key={model.id}
                                className={`p-2 text-[var(--text-primary)] hover:bg-[var(--hover-bg)] transition-all flex items-center ${model.isEnabled ? "cursor-pointer" : "cursor-not-allowed"
                                    }`}
                                onClick={() => model.isEnabled ? handleModelSelect(model.value) : null}
                                role={model.isEnabled ? "button" : undefined}
                                tabIndex={model.isEnabled ? 0 : -1}
                                aria-disabled={!model.isEnabled}
                            >
                                {model.icon}
                                <span className="ml-2 fs12">{model.displayName}</span>
                            </li>
                        </MatToolTip>
                    ))}
                </ul>
            </OverlayPanel>
            <OverlayPanel ref={collectionsDialogRef} className="w-56 bg-[var(--overlay-bg)]">
                <p className="text-[var(--overlay-text)] fs12 mb-2 px-2">Your Collections</p>
                <hr className="bg-[var(--overlay-border)] my-0" />
                <ul className="w-full !pl-0 list-none mb-0 overflow-y-auto max-h-48 chatscreen-custom-scrollbar">
                    {collections.map((collection) => (
                        <li
                            key={collection.id}
                            className={`p-2 text-[var(--text-primary)] hover:bg-[var(--hover-bg)] transition-all flex items-center
                                                ${selectedCollection.length > 0
                                    ? (selectedCollection.includes(collection.id) ? "bg-[var(--selected-bg)]" : "opacity-50")
                                    : ""
                                }
                                                ${isProcessing ? "cursor-not-allowed" : "cursor-pointer"}`}
                            onClick={() => handleCollectionSelect(collection)}
                        >
                            <GalleryVerticalEnd size={16} /> <span className='ml-2 fs11'>{collection.name}</span>
                        </li>
                    ))}
                </ul>
                <hr className="bg-[var(--overlay-border)] my-0" />
                <ul className="w-full !pl-0 list-none mb-0 fs11">
                    {menuData.map((menuItem, index) => (
                        <li
                            key={index}
                            className={`p-2 text-[var(--text-primary)] transition-all flex justify-between items-center gap-2 relative
                                                ${menuItem.isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-[var(--hover-bg)]'}`}
                            onMouseEnter={() => setSubmenuOpen(index)}
                            onMouseLeave={() => setSubmenuOpen(null)}
                        >
                            <div className='flex items-center'>{menuItem.icon && <span className='mr-2'>{menuItem.icon}</span>}
                                <span>{menuItem.label} </span> </div> {menuItem.items.length > 0 ? <ChevronRightIcon size={16} /> : ""}
                            {menuItem.items && submenuOpen === index && (
                                <ul className="absolute left-full !pl-0 top-0 bg-[var(--overlay-bg)] w-48 shadow-md py-0 list-none">
                                    {menuItem.items.map((subItem, subIndex) => (
                                        <li
                                            key={subIndex}
                                            className={`p-2 transition-all
                                                                ${subItem.isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-[var(--hover-bg)]'}
                                                                ${selectedEnvironmentId === subItem.id ? "bg-[var(--selected-bg)]" : ""}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (subItem.isDisabled) {
                                                    openSnackbar({
                                                        message: subItem.disabledMessage,
                                                        severity: 'info',
                                                        horizontalPos: 'left'
                                                    });
                                                } else {
                                                    subItem.command();
                                                }
                                            }}
                                        >
                                            {subItem.label}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </OverlayPanel>
            <OverlayPanel ref={chatDropDownOptionsRef} className="w-64 bg-[var(--overlay-bg)] border !border-[var(--borderColor)]">
                <AiAgentSidebar
                    isVisible={true}
                    onHide={() => setSidebarVisible(false)}
                    onSelectChat={handleSelectChat}
                    chatId={chatId}
                    selectedProject={selectedProject}
                />
            </OverlayPanel>
            <div className="flex-1 w-full overflow-hidden">
                {!showSplitter ? (
                    <CenteredChatLayout
                        messages={messages}
                        isLoadingOlder={isLoadingOlder}
                        hasMoreMessages={hasMoreMessages}
                        isProcessing={isProcessing}
                        userHasScrolled={userHasScrolled}
                        input={input}
                        setInput={setInput}
                        handleSubmit={handleSubmit}
                        handleKeyDown={handleKeyDown}
                        handleScroll={handleScroll}
                        loadOlderMessages={loadOlderMessages}
                        scrollToBottom={scrollToBottom}
                        handleCopy={handleCopy}
                        handleOpenTab={handleOpenTab}
                        onSuggestionClick={handlePromptClick}
                        isNewTabOpened={isNewTabOpened}
                        setIsNewTabOpened={setIsNewTabOpened}
                        latestMessageId={latestMessageId}
                        selectedCollection={selectedCollection}
                        selectedEnvironmentId={selectedEnvironmentId}
                        environment={environment}
                        collectionsDialogRef={collectionsDialogRef}
                        collectionsButtonRef={collectionsButtonRef}
                        chatDropDownOptionsRef={chatDropDownOptionsRef}
                        messagesContainerRef={messagesContainerRef}
                        messagesEndRef={messagesEndRef}
                        fileInputRef={fileInputRef}
                        handleFileUpload={handleFileUpload}
                        selectedProject={selectedProject}
                        user={user}
                        chatId={chatId}
                        handleSelectChat={handleSelectChat}
                        setSidebarVisible={setSidebarVisible}
                        showEnvMemoryInput={showEnvMemoryInput}
                        saveInEnvironment={saveInEnvironment}
                        setSaveInEnvironment={setSaveInEnvironment}
                        saveInMemory={saveInMemory}
                        setSaveInMemory={setSaveInMemory}
                        generatedTestScenarios={generatedTestScenarios}
                        handleTryAgain={handleTryAgain}
                        modelsDialogRef={modelsDialogRef}
                        selectedAIModel={selectedAIModel}
                        aiModels={aiModels}
                        onPreviewDetected={() => {
                            setShowSplitter(true)
                            if (!isSidebarCollapsed) {
                                toggleSidebar()
                            }
                        }}
                    />
                ) : (
                    <Splitter
                        className={`splitterClass w-full h-[calc(100vh-45px)] bg-[var(--background-secondary)]`}
                    >
                        <SplitterPanel size={28} className="bg-[var(--agent-msg-primary-bg)] flex flex-col overflow-x-hidden overflow-y-auto">
                            <motion.div
                                initial={{ opacity: 0, y: 60 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                    type: 'spring',
                                    stiffness: 40,   // lower = softer bounce
                                    damping: 12,     // lower = more bounce, higher = quicker settle
                                    mass: 0.6,       // tweak feel of weight
                                    delay: 0.05,
                                }}
                                className="w-full p-2 bgPrimary shadow-md flex flex-row items-center gap-3"
                            >
                                <div id="collection-tooltip-wrapper" className="inline-block relative w-7">
                                    <Button
                                        id="collection-dropdown-wrapper"
                                        ref={collectionsButtonRef}
                                        className="w-auto px-2 py-2 bgPrimary hover:bg-[var(--hover-bg)] border !border-[var(--borderColor)] text-[var(--text-primary)] disabled:cursor-not-allowed rounded shadow-none"
                                        onClick={(e) => collectionsDialogRef.current.toggle(e)}
                                    >
                                        <MenuIcon size={13} />
                                    </Button>

                                    {selectedCollection.length > 0 && (
                                        <Tooltip target="#collection-tooltip-wrapper" content="Start a new chat to switch to a different collection" position="right" />
                                    )}
                                </div>
                                <div className="flex flex-row w-full gap-1 flex-nowrap text-[var(--text-primary)]">
                                    <div className="flex-1 flex items-center min-w-0">
                                        {selectedCollection.length > 0 ? (
                                            <div className="inline-flex items-center bg-transparent text-[var(--text-primary)] w-auto max-w-56">
                                                {selectedCollection.map((id) => {
                                                    const collection = collections.find((c) => c.id === id);
                                                    return collection ? (
                                                        <span key={id} className="flex items-center text-sm truncate max-w-full">
                                                            {collection.name}
                                                        </span>
                                                    ) : null;
                                                })}
                                            </div>
                                        ) : (
                                            <button
                                                className='flex items-center py-1 border-none bg-transparent hover:bg-[var(--hover-bg)] text-[var(--text-primary)] !rounded-md'
                                                onClick={() => collectionsButtonRef.current?.click()}
                                            >
                                                <span className='ml-1 text-sm'>Add a Collection</span>
                                            </button>
                                        )}
                                        {selectedCollection.length > 0 && selectedEnvironmentId && ", "}
                                        {selectedEnvironmentId && (
                                            <div className="inline-flex items-center bg-transparent text-[var(--text-primary)] max-w-56 w-fit">
                                                {(() => {
                                                    const env = environment.find((env) => env.id === selectedEnvironmentId);
                                                    return env ? (
                                                        <span className="flex items-center text-sm truncate max-w-full ml-1">
                                                            {env.title}
                                                        </span>
                                                    ) : null;
                                                })()}
                                            </div>
                                        )}
                                    </div>
                                    <div className="flex-shrink-0">
                                        <div className="flex items-center gap-1">
                                            <button
                                                className='flex items-center py-1 border-none bgPrimary hover:bg-[var(--hover-bg)] text-capitalize text-[var(--text-primary)] !rounded-md'
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    resetChatState();
                                                    history.replace('/ai-agent?newChat=true');
                                                }}
                                            >
                                                <Plus size={14} /> <span className='ml-1 text-sm'>New Chat</span>
                                            </button>
                                            <button
                                                className='flex items-center py-1 border-none bgPrimary hover:bg-[var(--hover-bg)]  text-capitalize text-[var(--text-primary)] !rounded-md'
                                                onClick={(e) => chatDropDownOptionsRef.current.toggle(e)}
                                            >
                                                <ChevronDownIcon size={14} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                            <motion.div
                                initial={{ opacity: 0, y: 60 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                    type: 'spring',
                                    stiffness: 40,   // lower = softer bounce
                                    damping: 12,     // lower = more bounce, higher = quicker settle
                                    mass: 0.6,       // tweak feel of weight
                                    delay: 0.05,
                                }}
                                ref={messagesContainerRef}
                                onScroll={handleScroll}
                                className="w-full flex-1 overflow-y-auto max-h-screen chatscreen-custom-scrollbar p-3"
                            >
                                {messages.length > 4 && hasMoreMessages && (
                                    <div className="w-full flex justify-center mb-5">
                                        <Button onClick={loadOlderMessages} disabled={isLoadingOlder} className="bg-transparent text-[var(--text-primary)] hover:bg-[var(--hover-bg)] border-none p-2 !rounded-lg">
                                            <CircleFadingArrowUp size={12} className="mr-2" /> {isLoadingOlder ? "Loading..." : "Load Older Messages"}
                                        </Button>
                                    </div>
                                )}
                                {isLoadingOlder && (
                                    <div className="text-center py-2 mb-5">
                                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--text-primary)] mx-auto"></div>
                                    </div>
                                )}
                                {!hasMoreMessages && messages.length > 0 && (
                                    <div className="text-center py-2 text-[var(--text-tertiary)] text-sm mb-5">
                                        No more messages to load
                                    </div>
                                )}

                                {messages.length === 0 ? (
                                    isLoading ? (
                                        <div className="flex items-center justify-center h-full">
                                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[var(--text-primary)]"></div>
                                        </div>
                                    ) : (
                                        <BlankScreen user={user} onSuggestionClick={handlePromptClick} />
                                    )
                                ) : (
                                    <>
                                        {messages.map((message, index) => (<MessageResponse
                                            key={message.id || index}
                                            message={message}
                                            latestMessageId={latestMessageId}
                                            index={index}
                                            handleCopy={handleCopy}
                                            handleOpenTab={handleOpenTab}
                                            chatId={chatId}
                                            onSuggestionClick={handlePromptClick}
                                            isNewTabOpened={isNewTabOpened}
                                            handleTryAgain={handleTryAgain}
                                            setIsNewTabOpened={setIsNewTabOpened}
                                        />))}
                                        <div ref={messagesEndRef} data-messages-end className="h-1" />
                                    </>
                                )}
                            </motion.div>
                            <motion.div
                                initial={{ opacity: 0, y: 60 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                    type: 'spring',
                                    stiffness: 40,   // lower = softer bounce
                                    damping: 12,     // lower = more bounce, higher = quicker settle
                                    mass: 0.6,       // tweak feel of weight
                                    delay: 0.05,
                                }}
                                className='w-full p-1'>
                                <div className="w-[96%] p-1 mx-auto mb-2 bgSecondary flex-none relative z-10 rounded-xl">
                                    {userHasScrolled && (
                                        <Button
                                            onClick={scrollToBottom}
                                            className="bg-[var(--button-primary)] hover:bg-[var(--button-primary-hover)] border-none p-2 !rounded-full shadow-md absolute bottom-48 left-1/2 transform -translate-x-1/2"
                                        >
                                            <ArrowDownIcon size={20} />
                                        </Button>
                                    )}
                                    {isProcessing && (
                                        <ThinkingIndicator />
                                    )}

                                    {!isProcessing && showEnvMemoryInput && (
                                        <div className="flex items-center gap-4 mb-2 px-2">
                                            <span className='text-[var(--text-secondary)]'>Save In: </span>
                                            <label className="flex items-center gap-2 text-sm text-[var(--text-secondary)] cursor-pointer hover:text-[var(--text-primary)] transition-colors">
                                                <input
                                                    type="checkbox"
                                                    checked={saveInEnvironment}
                                                    onChange={(e) => setSaveInEnvironment(e.target.checked)}
                                                    className="w-4 h-4 rounded border-[var(--borderColor)] bgSecondary text-[var(--primary-color)] focus:ring-[var(--primary-color)] focus:ring-offset-[var(--background-secondary)]"
                                                />
                                                Environment
                                            </label>
                                            <label className="flex items-center gap-2 text-sm text-[var(--text-secondary)] cursor-pointer hover:text-[var(--text-primary)] transition-colors">
                                                <input
                                                    type="checkbox"
                                                    checked={saveInMemory}
                                                    onChange={(e) => setSaveInMemory(e.target.checked)}
                                                    className="w-4 h-4 rounded border-[var(--borderColor)] bgSecondary text-[var(--primary-color)] focus:ring-[var(--primary-color)] focus:ring-offset-[var(--background-secondary)]"
                                                />
                                                Memory
                                            </label>
                                        </div>
                                    )}
                                    <form
                                        onSubmit={(e) => e.preventDefault()}
                                        className="w-full mx-auto flex items-center rounded-lg overflow-hidden relative"
                                    >
                                        <div className="bgPrimary customBorder rounded-2 w-full relative z-10">
                                            <InputTextarea
                                                value={input}
                                                onChange={(e) => setInput(e.target.value)}
                                                onKeyDown={handleKeyDown}
                                                placeholder="Write what do you want to test..."
                                                className="w-full rounded-xl bg-transparent text-[var(--text-primary)] chat-custom-scrollbar shadow-none pr-11 !border-none"
                                                rows={4}
                                                autoResize
                                                style={{
                                                    whiteSpace: "pre-wrap",
                                                    wordBreak: "break-word",
                                                    minHeight: "48px",
                                                    maxHeight: "200px"
                                                }}
                                            />
                                            <Button
                                                type="button"
                                                onClick={handleSubmit}
                                                disabled={!input || !input.trim() || isProcessing}
                                                icon={
                                                    isProcessing ? (
                                                        <LoaderCircle size={16} className="animate-spin" />
                                                    ) : (
                                                        <SendHorizonal size={16} className="fly-animation" />
                                                    )
                                                }
                                                className="absolute right-3 top-2 w-auto h-8 bg-[var(--primary-color)] disabled:bg-[var(--primary-color-light)] hover:bg-[var(--primary-color-light)] border-none text-white px-2 py-1 m-1 !rounded shadow-md transition-all duration-150"
                                            />
                                            <Button
                                                type="button"
                                                onClick={(e) => modelsDialogRef.current.toggle(e)}
                                                aria-label='AI Model'
                                                icon={aiModels.find((model) => model.value === selectedAIModel)?.icon}
                                                className="fs10 flex items-center absolute right-3 bottom-2 w-auto h-8 bgPrimary hover:!bg-[var(--background-secondary)] border-none text-[var(--text-primary)] px-2 py-1 m-1 !rounded transition-all duration-150 outline-none shadow-none"
                                            >
                                                <span className='ml-1'>{aiModels.find((model) => model.value === selectedAIModel)?.displayName}</span> <ChevronDown size={12} className='ml-1' />
                                            </Button>
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                className="hidden"
                                                onChange={(e) => console.log("Uploaded:", e.target.files)}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </motion.div>
                        </SplitterPanel>
                        <SplitterPanel size={72} className="overflow-x-auto overflow-y-hidden bg-[var(--background-primary)]">
                            <motion.div
                                className="w-full"
                            >
                                <Tabs
                                    value={activeIndex}
                                    onChange={(e, newIndex) => setActiveIndex(newIndex)}
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    sx={{
                                        "& .MuiTabs-indicator": {
                                            backgroundColor: "var(--primary-color)",
                                            top: 0,
                                            bottom: "auto",
                                        },
                                        "& .MuiTab-root": { minHeight: 42.6, textTransform: "none", fontSize: "14px" },
                                        "& .MuiTab-label": { fontWeight: "500" },
                                        backgroundColor: "var(--background-primary)",
                                        borderBottom: "1px solid var(--borderColor)",
                                    }}
                                    className='!min-h-10'
                                >
                                    {tabs.map((tab, index) => (
                                        <Tab
                                            key={tab.id}
                                            label={
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        maxWidth: "110px",
                                                        overflow: "hidden",
                                                        padding: "3px",
                                                    }}
                                                >
                                                    {activeIndex === index && tab.type !== "new" && tab.type !== "progress" ? (
                                                        loadingTabs[tab.id] ? (
                                                            <MatToolTip title="Refreshing..." placement='top'>
                                                                <Refresh fontSize="medium" className="animate-spin" sx={{ color: "var(--primary-color)" }} />
                                                            </MatToolTip>
                                                        ) : (
                                                            <MatToolTip title="Refresh" placement='top'>
                                                                <Refresh
                                                                    fontSize="medium"
                                                                    sx={{ color: "var(--primary-color)", cursor: "pointer" }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        refreshTab(tab.id);
                                                                    }}
                                                                />
                                                            </MatToolTip>
                                                        )
                                                    ) : (
                                                        <div className='min-w-5'>
                                                            {tab.icon ? (tab.icon) : <Monitor fontSize="small" sx={{ color: activeIndex === index ? "var(--primary-color)" : "var(--text-primary)" }} />}
                                                        </div>
                                                    )}
                                                    <MatToolTip title={tab.title} placement="top">
                                                        <Typography
                                                            variant="body2"
                                                            noWrap
                                                            sx={{
                                                                overflow: "hidden",
                                                                maxWidth: "60px",
                                                                display: "inline-block",
                                                                textOverflow: "clip",
                                                                color: "var(--text-primary)",
                                                            }}
                                                        >
                                                            {tab.title}
                                                        </Typography>
                                                    </MatToolTip>
                                                    {tab.type !== "new" && tab.type !== "progress" && (
                                                        <IconButton
                                                            size="small"
                                                            sx={{
                                                                color: "var(--text-secondary)",
                                                                transition: "color 0.2s",
                                                                "&:hover": { color: "red" },
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleCloseTab(tab.id);
                                                            }}
                                                        >
                                                            <CloseIcon fontSize="small" />
                                                        </IconButton>
                                                    )}
                                                </Box>
                                            }
                                            sx={{
                                                backgroundColor: activeIndex === index ? "var(--background-secondary)" : "",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                padding: "0px 16px",
                                                minHeight: "48px",
                                                maxWidth: "120px",
                                                color: activeIndex === index ? "var(--primary-color)" : "var(--text-primary)",
                                                transition: "color 0.3s ease",
                                                "&:hover": { backgroundColor: activeIndex !== index ? "var(--agent-secondaryLight)" : "" },
                                            }}
                                        />
                                    ))}
                                </Tabs>
                                <motion.div
                                    initial={{ opacity: 0, y: 60 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{
                                        type: 'spring',
                                        stiffness: 40,   // lower = softer bounce
                                        damping: 12,     // lower = more bounce, higher = quicker settle
                                        mass: 0.6,       // tweak feel of weight
                                        delay: 0.05,
                                    }}
                                    className="max-h-[calc(100vh-92px)] overflow-y-auto chatscreen-custom-scrollbar bg-[var(--background-primary)]">
                                    {tabs.map((tab, index) =>
                                        tabComponents[tab.type] && selectedProject &&
                                            (!tabTypesForConditionalRender.includes(tab.type) || activeIndex === index) ? (
                                            <div
                                                key={`tab${tab.id}-${refreshKeys[tab.id] || 0}`}
                                                className={`relative min-h-[calc(100vh-92px)] uniqueClass text-[var(--text-primary)] ${getTabBgClass(tab.type)} ${!tabTypesForConditionalRender.includes(tab.type) && activeIndex !== index ? 'hidden' : ''
                                                    }`}
                                            >
                                                {tabComponents[tab.type](tab)}
                                            </div>
                                        ) : null
                                    )}
                                </motion.div>
                            </motion.div>
                        </SplitterPanel>
                    </Splitter>
                )}
                <input
                    type="file"
                    ref={fileInputRefImport}
                    style={{ display: 'none' }}
                    accept={fileAccept}
                    onChange={(e) => { handleImportCollections(e, selectedImportType) }}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        project: state.common.selectedProject,
        organisations: state.common.organisations,
        currentUser: state.user.current_user
    };
};
export default connect(mapStateToProps)(TestCaseGeneratorBot);